import { BaseComponent } from "utils/base-component"
import { bindPasswordToggle } from "utils/password-toggle"

import "./login.scss"
import "./login-full-page.scss"
import "./static/background.jpg"

export class Login extends BaseComponent {
  static cssClass = "login"

  init() {
    bindPasswordToggle(this.root)
  }
}
